import { staticEntityReducerTemplate } from '../reducerUtils';

export default staticEntityReducerTemplate('cities');



// WEBPACK FOOTER //
// ./src/reducers/entities/citiesReducer.js